<template>
    <div class="wrapper">
      <div class="container">
        <div class="right-column" :class="{ 'hovered': isHoverRight }" @mouseover="isHoverRight = true">
          <h2>register</h2>
          <el-form :model="regusterUser" :rules="Rrules" ref="regusterUser">
            <el-form-item prop="userName">
              <el-input auto-complete="new-password" size="medium" prefix-icon="el-icon-user" v-model="regusterUser.userName" placeholder="please enter user name"></el-input>
            </el-form-item>
            
            <el-form-item prop="password">
              <el-input auto-complete="new-password" size="medium" prefix-icon="el-icon-lock" v-model="regusterUser.password" placeholder="Please enter password" show-password></el-input>
            </el-form-item>
            <el-form-item prop="confirmPassword">
              <el-input auto-complete="new-password" size="medium" prefix-icon="el-icon-lock" v-model="regusterUser.confirmPassword" placeholder="Please confirm your password" show-password></el-input>
            </el-form-item>
            <el-form-item class="phone-form"  prop="phone">
              <el-input    auto-complete="new-password"  size="medium" prefix-icon="el-icon-mobile-phone" v-model="regusterUser.phone" placeholder="Please enter the machine number"></el-input>
              <el-select v-model="value" placeholder="Please select the model" style="margin-top:10px">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
           
            <template>
              <el-radio v-model="radio" label="1">Regular User</el-radio>
              <el-radio v-model="radio" label="2">Administrator</el-radio>
          </template>
            <el-form-item style="margin-top: 25px;">
              <el-button type="primary" size="medium" @click="register('regusterUser')">register</el-button>
              <el-button type="primary" size="medium" @click="switchLogin()">Log in</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import request from '@/utils/request';
  import md5 from 'js-md5'
  
  export default {
    name: "Register",
    data() {
      return {
        value:'white808',
        options: [{
          value: 'cl4',
          label: 'cl4'
        }, {
          value: 'white808',
          label: '808_W'
        }, {
          value: 'black808',
          label: '808_B'
        }, {
          value: 'cl4Face',
          label: 'cl4Face'
        }],
        radio:'1',
        regusterUser: {
          phone:'',
          userName: '',
          password: '',
          confirmPassword: ''
        },
        sendUser:{},
        Rrules: {
          userName: [
            { required: true, message: 'please enter user name', trigger: 'blur' },
            { min: 3, max: 12, message: '3 to 12 characters in length', trigger: 'blur' }
          ],
          password: [
            { required: true, message: 'Please enter password', trigger: 'blur' },
            { min: 6, max: 20, message: '6 to 20 characters in length', trigger: 'blur' }
          ],
          confirmPassword: [
            { required: true, message: 'Please confirm your password', trigger: 'blur' },
            { validator: this.validateConfirmPassword, trigger: 'blur' }
          ]
        },
        isHoverRight: false,
      };
    },
    methods: {
      switchLogin(){
        this.$router.push('/login')
      },
      register(formName) {
        console.log("model " + this.value)
        this.sendUser.passWorld = md5(this.regusterUser.password)
        this.sendUser.userName = this.regusterUser.userName
        this.sendUser.phoneNum = this.regusterUser.phone
        if(this.radio =='2'){
          this.sendUser.level = '1'
        }
        this.$refs[formName].validate((valid) => {
          if (valid) {
            request.post("/users/register", this.sendUser, {
                params: {
                    mode: this.value 
                }}).then(res =>{
                if(res.code==="USERNAME_REPEAT"){
                    this.$message.error("Username already exists, please re-enter it")
                }
                else if (res.code ==="SUCCESS"){
                    this.$message.success("Registration successful, please log in")
                    this.$router.push('/login')
                }
                else if(res.code === "SERVER_ERROR"){
                    this.$message.error("Server internal error")
                }
                else if(res.code ==="MACHINE_NOT_FIND"){
                    this.$message.error("Machine number not found, registration failed")
                }
                else if (res.code ==="PHONENUM_REPEAT"){
                    this.$message.error("The machine has been registered")
                }
            })
          } else {
            return false;
          }
        });
      },
      validateConfirmPassword(rule, value, callback) {
        if (value !== this.regusterUser.password) {
          callback(new Error('The passwords entered twice are inconsistent'));
        } else {
          callback();
        }
      }
    },
  };
  </script>
  
  <style scoped>
  .wrapper {
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #04112b; 
  }
  
  .container {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    max-width: 800px;
  }
  
  .right-column {
    flex: 1;
    padding: 20px;
    background-color: #fff;
    border-radius: 10px;
    box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.2);
    cursor: pointer;
    transition: transform 0.5s ease, box-shadow 0.5s ease;
    transform-origin: center center;
  }
  
  .right-column.hovered {
    transform: perspective(1000px) scale(1.2) rotateY(0deg);
    box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.3);
  }
  
  </style>